export default {
  name: 'nom',
  username: "nom d'utilisateur",
  email: 'adresse email',
  first_name: 'prénom',
  last_name: 'nom',
  password: 'mot de passe',
  password_confirmation: 'confirmation du mot de passe',
  city: 'ville',
  country: 'pays',
  postal_code: 'code postal',
  address: 'adresse',
  phone: 'téléphone',
  mobile: 'portable',
  age: 'âge',
  sex: 'sexe',
  gender: 'genre',
  birthdate: 'date de naissance',
  day: 'jour',
  month: 'mois',
  year: 'année',
  hour: 'heure',
  minute: 'minute',
  second: 'seconde',
  title: 'titre',
  content: 'contenu',
  description: 'description',
  excerpt: 'extrait',
  date: 'date',
  time: 'heure',
  available: 'disponible',
  size: 'taille',
  brand: 'marque'
}
